import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
export class ChangeMaskinlagForArbetsorderOperationCommand extends BasicCommand<ChangeMaskinlagForArbetsorderOperationCommand> {
    get primaryKey(): IPrimaryKey<ChangeMaskinlagForArbetsorderOperationCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    maskinlagId: number;
    startdatum: Date;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ChangeMaskinlagForArbetsorderOperationCommand";
    constructor(init: (instance: ChangeMaskinlagForArbetsorderOperationCommand) => void) {
        super(ChangeMaskinlagForArbetsorderOperationCommand.$type, ChangeMaskinlagForArbetsorderOperationCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
